import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { UnsupportedBrowserComponent } from './app/00_modules/browser-management/unsupported-browser/unsupported-browser.component';
import { ProviderIntegrationComponent } from './app/00_modules/integration/provider-integration/provider-integration.component';

if (environment.production) {
    enableProdMode();
}

/**
 * Conditional bootstrapping logic (IE/Firefox-Detection, Integration-Mode)
 * This replaces the previous ngDoBootstrap() pattern from AppModule
 */
function bootstrap(): void {
    const regexForUnsupportedBrowsers = new RegExp(/(?:\\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:)(\d+)/);
    const isUnsupportedBrowser = regexForUnsupportedBrowsers.test(navigator.userAgent) || navigator.userAgent.includes('Firefox');

    let componentToBootstrap: any;

    if (isUnsupportedBrowser) {
        componentToBootstrap = UnsupportedBrowserComponent;
    } else if (window.location.hash && window.location.hash.indexOf('#/integration') === 0) {
        componentToBootstrap = ProviderIntegrationComponent;
    } else {
        componentToBootstrap = AppComponent;
    }

    bootstrapApplication(componentToBootstrap, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] }).catch(err => console.error(err));
}

bootstrap();
